import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('@/components/Login')
const Regis = () => import('@/components/Regis')
const Dashboard = () => import('@/components/Dashboard')
const Workshop = () => import('@/components/Workshop')
const Activity = () => import('@/components/Activity')
const Profile = () => import('@/components/Profile')
const Checkin = () => import('@/components/Checkin')

Vue.use(Router)

const titlename = 'RMUTL OPEN HOUSE เปิดบ้านราชมงคลล้านนา'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { title: '' }
    },
    {
      path: '/regis/:id',
      name: 'Regis',
      component: Regis,
      meta: { title: 'Register' }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { title: 'Dashboard' }
    },
    {
      path: '/workshop',
      name: 'Workshop',
      component: Workshop,
      meta: { title: 'Workshop' }
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
      meta: { title: 'Activity' }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { title: 'Profile' }
    },
    {
      path: '/checkin',
      name: 'Checkin',
      component: Checkin,
      meta: { title: 'Checkin' }
    }
  ]
})

router.afterEach((to, from) => {
  document.title = to.meta.title ? to.meta.title + ' | ' + titlename : titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js